"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames7 = _interopRequireDefault(require("classnames"));
var _debounce2 = _interopRequireDefault(require("lodash/debounce"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _striptags = _interopRequireDefault(require("striptags"));
var _cccisdColorPicker = require("cccisd-color-picker");
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right2"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/svg/checkmark"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
var _menu = _interopRequireDefault(require("cccisd-icons/menu7"));
var _arrowLeft = _interopRequireDefault(require("cccisd-icons/arrow-left12"));
var _arrowLeft2 = _interopRequireDefault(require("cccisd-icons/arrow-left8"));
var _lock = _interopRequireDefault(require("cccisd-icons/svg/lock4"));
var _circle = _interopRequireDefault(require("cccisd-icons/circle"));
var _circle2 = _interopRequireDefault(require("cccisd-icons/circle2"));
var _arrowRight2 = _interopRequireDefault(require("cccisd-icons/arrow-right8"));
var _cccisdLaravelFlow = require("cccisd-laravel-flow");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdSideMenu = _interopRequireDefault(require("cccisd-side-menu"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _useWithModulesMediator = _interopRequireDefault(require("./useWithModulesMediator"));
var _Settings = require("../Settings");
var _LessonCard = _interopRequireDefault(require("./components/LessonCard"));
var _Bookmark = _interopRequireDefault(require("./components/PinnedContent/Bookmark"));
var _Link = _interopRequireDefault(require("./components/PinnedContent/Link"));
var _Resource = _interopRequireDefault(require("./components/PinnedContent/Resource"));
var _Wysiwyg = _interopRequireDefault(require("./components/PinnedContent/Wysiwyg"));
var _style = _interopRequireDefault(require("./style.css"));
var _style2 = _interopRequireDefault(require("../../courseWrapper/Mediator/style.css"));
var _useOverlayBgStyles = _interopRequireDefault(require("../../courseWrapper/Mediator/useOverlayBgStyles"));
var _aspectRatioOptions = _interopRequireDefault(require("../Settings/aspectRatioOptions.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var translate = {
  en: {
    lessonText: 'LESSON',
    moduleOptional: 'indicates optional content',
    moduleRequired: 'indicates required content',
    moduleText: 'MODULE',
    nextModule: 'Next @@',
    // will replace @@ with module label
    overview: 'Overview',
    previousModule: 'Previous @@' // will replace @@ with module label
  },
  es: {
    lessonText: 'LECCIÓN',
    moduleOptional: 'indica contenido opcional',
    moduleRequired: 'indica contenido requerido',
    moduleText: 'MÓDULO',
    nextModule: '$$ Próximo',
    // will replace @@ with module label
    overview: 'El Resumen',
    previousModule: '$$ Anterior' // will replace @@ with module label
  }
};
var screenSm = Number(_style["default"].screenSm.replace('px', ''));
var NestedContextProvider = function NestedContextProvider(_ref) {
  var context = _ref.context,
    value = _ref.value,
    children = _ref.children;
  var prevValue = (0, _react.useContext)(context);
  var mergedValue = _objectSpread(_objectSpread({}, prevValue), value);
  var Provider = context.Provider;
  return /*#__PURE__*/_react["default"].createElement(Provider, {
    value: mergedValue
  }, children);
};
var WithModulesMediator = function WithModulesMediator(props) {
  var mediatorProps = props.mediatorProps,
    _props$courseWrapperM = props.courseWrapperMediatorProps,
    courseWrapperMediatorProps = _props$courseWrapperM === void 0 ? {} : _props$courseWrapperM,
    isNetworkError = props.isNetworkError,
    onPlayerShow = props.onPlayerShow,
    onPlayerHide = props.onPlayerHide;
  var overlayBgStyles = (0, _useOverlayBgStyles["default"])(courseWrapperMediatorProps.currentLayout, courseWrapperMediatorProps.setIsShowingLayoutBgColor);
  var _useState = (0, _react.useState)(window.innerWidth < screenSm),
    _useState2 = _slicedToArray(_useState, 2),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    modalSize = _useState4[0],
    setModalSize = _useState4[1];
  var language = Object.keys(translate).includes(props.language) ? props.language : 'en';
  var settings = _objectSpread(_objectSpread({}, _Settings.initialValues), mediatorProps);
  var mustTakeInOrder = settings.mustTakeInOrder,
    showLastVisited = settings.showLastVisited,
    showLessonNum = settings.showLessonNum,
    showProgressBubbleNum = settings.showProgressBubbleNum,
    showLessonsInModal = settings.showLessonsInModal,
    highlighting = settings.highlighting,
    requiredHighlightColor = settings.requiredHighlightColor,
    optionalHighlightColor = settings.optionalHighlightColor,
    baseColor = settings.baseColor,
    buttonColors = settings.buttonColors,
    progressBubbleColors = settings.progressBubbleColors,
    labelForLessonEn = settings.labelForLessonEn,
    labelForModuleEn = settings.labelForModuleEn,
    labelForLessonEs = settings.labelForLessonEs,
    labelForModuleEs = settings.labelForModuleEs;
  var _useWithModulesMediat = (0, _useWithModulesMediator["default"])(_objectSpread(_objectSpread({}, props), {}, {
      mustTakeInOrder: mustTakeInOrder
    })),
    closeFlowPlayer = _useWithModulesMediat.closeFlowPlayer,
    currentFlowProps = _useWithModulesMediat.currentFlowProps,
    entityCompletionMap = _useWithModulesMediat.entityCompletionMap,
    initialEntityId = _useWithModulesMediat.initialEntityId,
    isAllComplete = _useWithModulesMediat.isAllComplete,
    isAllRequiredComplete = _useWithModulesMediat.isAllRequiredComplete,
    isLoading = _useWithModulesMediat.isLoading,
    modules = _useWithModulesMediat.modules,
    moduleCompletionMap = _useWithModulesMediat.moduleCompletionMap,
    pinnedContentMap = _useWithModulesMediat.pinnedContentMap,
    setCurrentFlowAndEntity = _useWithModulesMediat.setCurrentFlowAndEntity,
    surveyCompletionMap = _useWithModulesMediat.surveyCompletionMap;
  var currentModule = modules.length === 1 && modules[0].lessons ? modules[0] : modules.find(function (m) {
    return m.isActive;
  });
  var currentModuleIndex = modules.indexOf(currentModule);
  var baseColorHex = (0, _cccisdColorPicker.getColor)(baseColor);
  var isOneModule = modules.length <= 1;
  var isHideHeader = isOneModule && currentModule && !('title' in currentModule) && !('header' in currentModule);
  var forceAspectRatio = Boolean(mediatorProps.showLessonsInModal && mediatorProps.aspectRatio);
  var modalRef = (0, _react.useRef)();
  var modalBgRef = (0, _react.useRef)();
  var flowRef = (0, _react.useRef)();
  var prevSize = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (modalRef && modalRef.current) modalRef.current.open();
  }, [modalRef.current, currentFlowProps]);
  (0, _react.useEffect)(function () {
    function checkScreenWidth() {
      setIsMobile(window.innerWidth < screenSm);
    }
    window.addEventListener('resize', checkScreenWidth);
    return function () {
      return window.removeEventListener('resize', checkScreenWidth);
    };
  }, [isMobile]);
  var handleWindowResize = (0, _react.useCallback)((0, _debounce2["default"])(function () {
    var _prevSize$current, _prevSize$current2;
    if (!forceAspectRatio) {
      return;
    }
    var flowArea = flowRef.current;
    var contentArea = document.getElementById('cccisd-flow-content-area');
    if (!contentArea || !flowArea) {
      return;
    }
    var aspectRatio = function () {
      var option = _aspectRatioOptions["default"].find(function (item) {
        return item.value === mediatorProps.aspectRatio;
      });
      return option ? option.aspectRatio : null;
    }();
    if (!aspectRatio) {
      return;
    }
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var flowRect = flowArea.getBoundingClientRect();
    var contentRect = contentArea.getBoundingClientRect();
    var extraHeight = flowRect.height - contentRect.height;
    var extraWidth = flowRect.width - contentRect.width;
    var windowPadding = 16;
    var mobileNavHeight = 36;
    var availableHeight = windowHeight - windowPadding * 2 - mobileNavHeight - extraHeight;
    var availableWidth = windowWidth - windowPadding * 2 - extraWidth;
    var contentWidth = Math.min(availableWidth, availableHeight * aspectRatio);
    var contentHeight = contentWidth / aspectRatio + 1; // +1 just to fix rounding issues

    var width = contentWidth + extraWidth;
    var height = contentHeight + extraHeight + mobileNavHeight;
    if (width !== ((_prevSize$current = prevSize.current) === null || _prevSize$current === void 0 ? void 0 : _prevSize$current.width) || height !== ((_prevSize$current2 = prevSize.current) === null || _prevSize$current2 === void 0 ? void 0 : _prevSize$current2.height)) {
      // changing the flow content height using css variable
      document.documentElement.style.setProperty('--cccisd-flow-content-area-height', contentHeight + 'px');
      prevSize.current = {
        width: width,
        height: height
      };
      setModalSize({
        width: width,
        height: height
      });
    }
  }, 100), []);
  (0, _react.useEffect)(function () {
    if (!currentFlowProps || !forceAspectRatio) {
      return;
    }
    window.addEventListener('resize', handleWindowResize);
    return function () {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, [currentFlowProps, forceAspectRatio]);
  (0, _react.useEffect)(function () {
    if (!currentFlowProps || !forceAspectRatio) {
      return;
    }
    if (modalBgRef.current) {
      var observer = new MutationObserver(handleWindowResize);
      observer.observe(modalBgRef.current, {
        childList: true,
        subtree: true
      });
      return function () {
        return observer.disconnect();
      };
    }
  }, [currentFlowProps, forceAspectRatio]);
  (0, _react.useEffect)(function () {
    if (currentFlowProps && onPlayerShow) {
      onPlayerShow({
        currentFlowProps: currentFlowProps
      });
    } else if (!currentFlowProps && onPlayerHide) {
      onPlayerHide();
    }
  }, [currentFlowProps]);
  function getHighlightColor() {
    switch (highlighting) {
      case '':
        return '';
      case 'required':
        return requiredHighlightColor in _style["default"] ? _style["default"][requiredHighlightColor] : requiredHighlightColor;
      case 'optional':
        return optionalHighlightColor in _style["default"] ? _style["default"][optionalHighlightColor] : optionalHighlightColor;
      default:
        console.error("Setting value '".concat(highlighting, "' is not a valid option for highlighting."));
        return '';
    }
  }
  function renderPlayerView() {
    if (!currentFlowProps) {
      return null;
    }
    var renderBreadcrumbs = function renderBreadcrumbs(_ref2) {
      var _currentModule$title;
      var inModal = _ref2.inModal;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].breadcrumbsWrapper,
        style: {
          marginBottom: inModal ? '0px' : '7px'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].breadcrumbs
      }, currentModule.title ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _striptags["default"])(((_currentModule$title = currentModule.title) === null || _currentModule$title === void 0 ? void 0 : _currentModule$title.content) || currentModule.title).replace(/&nbsp;/g, ' ').replace(/\*/g, ''), "\xA0\xA0", currentFlowProps.title && /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], null), "\xA0\xA0") : null, currentFlowProps.title && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: currentFlowProps.title
      })), !courseWrapperMediatorProps.renderCourseInOverlay && /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: _style["default"].closeButton,
        onClick: closeFlowPlayer
      }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)));
    };
    var playerView = /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].flow,
      ref: flowRef
    }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelFlow.Player, _extends({
      key: currentFlowProps.handle,
      isNetworkError: isNetworkError
    }, currentFlowProps, {
      pageFirstElementId: initialEntityId
    })));
    if (courseWrapperMediatorProps.renderCourseInOverlay) {
      return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        size: "calc(100vw - 40px)",
        bodyStyle: overlayBgStyles.style,
        ref: modalRef,
        modalClassName: _style2["default"].courseWrapperInOverlayModal,
        title: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: 'flex',
            gap: '1em',
            alignItems: 'center'
          }
        }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: courseWrapperMediatorProps.modalHeaderImageUrl ? "<img src=\"".concat(courseWrapperMediatorProps.modalHeaderImageUrl, "\" alt=\"").concat(courseWrapperMediatorProps.modalHeaderImageFileName, "\" height=\"36\" data-image=\"980\" />") : ''
        }), renderBreadcrumbs({
          inModal: true
        }))),
        afterClose: closeFlowPlayer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].flow,
        "data-cccisd-survey-area": true
      }, playerView));
    }
    var playerContent = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isMobile || showLessonsInModal ? renderModuleNav() : renderBreadcrumbs({
      inModal: false
    }), playerView);
    var isAspectRatio = Boolean(forceAspectRatio && modalSize);
    return showLessonsInModal ? /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames7["default"])(_style["default"].playerViewModal, isAspectRatio && _style["default"].withAspectRatio),
      "data-cccisd-survey-area": true,
      ref: modalBgRef
    }, /*#__PURE__*/_react["default"].createElement("div", _extends({
      className: (0, _classnames7["default"])(!isAspectRatio && _style["default"].sizeBox, forceAspectRatio && !isAspectRatio && _style["default"].hidden)
    }, isAspectRatio ? {
      style: {
        width: modalSize.width + 'px',
        height: modalSize.height + 'px'
      },
      'data-cccisd-survey-area': true
    } : {}), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].playerContent
    }, playerContent))) : playerContent;
  }
  function renderModuleView() {
    if (currentFlowProps || !currentModule) {
      return null;
    }
    var topLevelPinned = (0, _get2["default"])(pinnedContentMap, 'topLevel', []) || [];
    return /*#__PURE__*/_react["default"].createElement("div", null, Array.isArray(topLevelPinned) && topLevelPinned.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].topLevelPinned
    }, topLevelPinned.map(renderPinnedContent)), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: isMobile ? 'block' : 'flex'
      }
    }, renderModuleNav(), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].content
    }, renderHeader(), renderLessonArea())));
  }
  function renderModuleNav() {
    if (isOneModule && !currentFlowProps) {
      return null;
    }
    if (isMobile || showLessonsInModal && currentFlowProps) {
      var renderCollapseNav = function renderCollapseNav(closeNavigation) {
        return /*#__PURE__*/_react["default"].createElement("button", {
          className: 'btn btn-secondary ' + _style["default"].closeButton,
          onClick: closeNavigation,
          type: "button"
        }, /*#__PURE__*/_react["default"].createElement(_arrowLeft["default"], null));
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].mobileNav
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSideMenu["default"], {
        renderCloseButton: function renderCloseButton(_ref3) {
          var _currentModule$icon;
          var closeNavigation = _ref3.closeNavigation;
          return currentFlowProps ? /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].mobileNavCloseButton
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: (0, _classnames7["default"])(_defineProperty({}, _style["default"].mobileNavCloseButtonActiveLesson, !isHideHeader))
          }, renderCollapseNav(closeNavigation)), !isHideHeader && /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].moduleIconTitleFlex
          }, (currentModule === null || currentModule === void 0 ? void 0 : (_currentModule$icon = currentModule.icon) === null || _currentModule$icon === void 0 ? void 0 : _currentModule$icon.thumbnailSmall) && /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              backgroundImage: "url(".concat(currentModule.icon.thumbnailSmall, ")")
            },
            className: _style["default"].moduleTitleIcon
          }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
            className: _style["default"].moduleHeaderInMenu,
            style: {
              color: "".concat(baseColorHex)
            }
          }, getModuleHeaderText(currentModule)), /*#__PURE__*/_react["default"].createElement("p", {
            className: _style["default"].moduleTitleInMenu
          }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
            content: currentModule.title
          }))))) : /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].mobileNavCloseButton
          }, renderCollapseNav(closeNavigation));
        },
        renderTabs: function renderTabs(_ref4) {
          var closeNavigation = _ref4.closeNavigation;
          return currentFlowProps ? /*#__PURE__*/_react["default"].createElement("ul", {
            className: _style["default"].mobileNavLessonMenu
          }, currentModule.lessons.map(function (les, i) {
            return /*#__PURE__*/_react["default"].createElement("li", {
              onClick: function onClick() {
                if (!les.isAllowed) {
                  return;
                }
                les.setCurrent();
                closeNavigation();
              },
              key: (les.title || les.handle) + i,
              className: (0, _classnames7["default"])(_defineProperty(_defineProperty(_defineProperty({}, _style["default"].locked, !les.isAllowed), _style["default"].complete, les.isCompleted && les.isAllowed), _style["default"].active, currentFlowProps.flowId === les.flowId))
            }, /*#__PURE__*/_react["default"].createElement("span", null, (showLessonNum || !!getLessonHighlight(les)) && /*#__PURE__*/_react["default"].createElement("p", {
              className: _style["default"].lessonText,
              style: {
                color: "".concat(baseColorHex)
              }
            }, getLessonHighlight(les), showLessonNum && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "".concat(getLessonLabel().toUpperCase(), " ").concat(i + 1))), les.title && /*#__PURE__*/_react["default"].createElement("span", null, typeof les.title === 'string' ? /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
              content: les.title
            }) : /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
              content: les.title.content
            }))), !les.isAllowed && /*#__PURE__*/_react["default"].createElement("span", {
              className: _style["default"].icon
            }, /*#__PURE__*/_react["default"].createElement(_lock["default"], null)), les.isCompleted && /*#__PURE__*/_react["default"].createElement("span", {
              className: _style["default"].icon
            }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)));
          }), currentModule.lessons.some(function (lesson) {
            return highlighting === 'required' && lesson.isRequired || highlighting === 'options' && !lesson.isRequired;
          }) && /*#__PURE__*/_react["default"].createElement("div", {
            className: "".concat(_style["default"].menuHighlightKey, " ").concat(_style["default"].mobile)
          }, renderHighlightKey())) : /*#__PURE__*/_react["default"].createElement("div", {
            className: "".concat(_style["default"].sidebar, " ").concat(_style["default"].mobile)
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].moduleNav
          }, renderModulesList(closeNavigation)));
        },
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-xs btn-secondary",
          type: "button"
        }, /*#__PURE__*/_react["default"].createElement(_menu["default"], null))
      }), currentFlowProps && /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-xs btn-secondary",
        type: "button",
        onClick: closeFlowPlayer
      }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].sidebar
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].moduleNav
    }, renderModulesList()));
  }
  function renderModulesList() {
    var closeNavigation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    var isAnyModuleHighlighted = highlighting === 'optional' && modules.some(function (m) {
      return m.lessons.every(function (les) {
        return !les.isRequired;
      });
    }) || highlighting === 'required' && modules.some(function (m) {
      return m.lessons.some(function (les) {
        return les.isRequired;
      });
    });
    return /*#__PURE__*/_react["default"].createElement("div", null, modules.map(function (module) {
      var _module$icon;
      var handleClick = function handleClick() {
        if (module.lessons.length > 0 && module.isAllowed) {
          module.setActive();
          closeNavigation();
        }
      };
      var isHighlighted;
      switch (highlighting) {
        case 'required':
          isHighlighted = module.lessons.some(function (les) {
            return les.isRequired;
          });
          break;
        case 'optional':
          isHighlighted = module.lessons.every(function (les) {
            return !les.isRequired;
          });
          break;
        default:
        // leave undefined
      }
      if (module.isEmpty) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: module.id,
        className: (0, _classnames7["default"])(_style["default"].item, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _style["default"].allowed, module.isAllowed), _style["default"].current, module.isActive), _style["default"].notStarted, module.showDimmed), _style["default"].beforeActive, modules.indexOf(module) === currentModuleIndex - 1), _style["default"].extraPad, isAnyModuleHighlighted)),
        style: module.isActive && baseColor ? {
          borderBottom: "1px solid ".concat(baseColorHex),
          borderLeft: "0.45rem solid ".concat(baseColorHex),
          borderTop: "1px solid ".concat(baseColorHex)
        } : {},
        onClick: handleClick
      }, isHighlighted && /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames7["default"])(_style["default"].moduleIcon, _style["default"].highlightIcon),
        style: {
          color: getHighlightColor()
        }
      }, highlighting === 'required' ? /*#__PURE__*/_react["default"].createElement(_circle2["default"], null) : /*#__PURE__*/_react["default"].createElement(_circle["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].moduleIconTitleFlex
      }, (module === null || module === void 0 ? void 0 : (_module$icon = module.icon) === null || _module$icon === void 0 ? void 0 : _module$icon.thumbnailSmall) && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          backgroundImage: "url(".concat(module.icon.thumbnailSmall, ")")
        },
        className: _style["default"].moduleTitleIcon
      }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
        className: _style["default"].moduleHeader,
        style: module.showDimmed ? {} : {
          color: "".concat(baseColorHex)
        }
      }, getModuleHeaderText(module)), /*#__PURE__*/_react["default"].createElement("p", {
        className: _style["default"].moduleTitle
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: module.title
      })))), module.isAllLessonsComplete && !module.showDimmed && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames7["default"])(_style["default"].moduleIcon, _style["default"].checkmark),
        style: {
          color: "".concat(baseColorHex)
        }
      }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)), !module.isAllowed && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].moduleIcon
      }, /*#__PURE__*/_react["default"].createElement(_lock["default"], null)));
    }), isMobile && isAnyModuleHighlighted && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].menuHighlightKey
    }, renderHighlightKey()));
  }
  function renderHighlightKey() {
    return /*#__PURE__*/_react["default"].createElement("p", {
      style: {
        color: getHighlightColor()
      }
    }, highlighting === 'required' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].highlightIcon
    }, /*#__PURE__*/_react["default"].createElement(_circle2["default"], null), "\xA0\xA0"), translate[language].moduleRequired) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].highlightIcon
    }, /*#__PURE__*/_react["default"].createElement(_circle["default"], null), "\xA0\xA0"), translate[language].moduleOptional));
  }
  function renderHeader() {
    if (isHideHeader) {
      return null;
    }
    var highlightMessage;
    switch (highlighting) {
      case 'required':
        highlightMessage = currentModule.lessons.some(function (les) {
          return les.isRequired;
        }) && /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].headerHighlightKey
        }, renderHighlightKey());
        break;
      case 'optional':
        highlightMessage = currentModule.lessons.some(function (les) {
          return !les.isRequired;
        }) && /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].headerHighlightKey
        }, renderHighlightKey());
        break;
      default:
      // leave undefined
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames7["default"])(_defineProperty(_defineProperty(_defineProperty({}, _style["default"].header, true), _style["default"].oneModule, isOneModule), _style["default"].isMobile, isMobile))
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
      className: _style["default"].headerModule,
      style: {
        color: "".concat(baseColorHex)
      }
    }, getModuleHeaderText(currentModule)), /*#__PURE__*/_react["default"].createElement("p", {
      className: _style["default"].headerTitle
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: currentModule.title
    }))), highlightMessage);
  }
  function getModuleHeaderText(module) {
    var content = 'header' in module ? module.header : "".concat(getModuleLabel(), " ").concat(module.id);
    if (!content) {
      return '';
    }
    return /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: content
    });
  }
  function getLessonLabel() {
    if (language === 'en' && labelForLessonEn) {
      return labelForLessonEn;
    }
    if (language === 'es' && labelForLessonEs) {
      return labelForLessonEs;
    }
    return translate[language].lessonText;
  }
  function getModuleLabel(translateKey) {
    var base = translate[language].moduleText;
    if (language === 'en' && labelForModuleEn) {
      base = labelForModuleEn;
    } else if (language === 'es' && labelForModuleEs) {
      base = labelForModuleEs;
    }
    if (!translateKey) {
      return base.toUpperCase();
    }
    var baseMessage = translate[language][translateKey];
    var replaceString = base[0].toUpperCase() + base.slice(1).toLowerCase();
    return baseMessage.replace('@@', replaceString);
  }
  function renderPinnedContent(content, i) {
    var commonProps = {
      content: content,
      entityCompletionMap: entityCompletionMap,
      isAllComplete: isAllComplete,
      isAllRequiredComplete: isAllRequiredComplete,
      language: language,
      moduleCompletionMap: moduleCompletionMap,
      surveyCompletionMap: surveyCompletionMap
    };
    var component = /*#__PURE__*/_react["default"].createElement("div", null);
    switch (content.type) {
      case 'resource':
        component = /*#__PURE__*/_react["default"].createElement(_Resource["default"], commonProps);
        break;
      case 'wysiwyg':
        component = /*#__PURE__*/_react["default"].createElement(_Wysiwyg["default"], commonProps);
        break;
      case 'link':
        component = /*#__PURE__*/_react["default"].createElement(_Link["default"], commonProps);
        break;
      case 'bookmark':
        component = /*#__PURE__*/_react["default"].createElement(_Bookmark["default"], _extends({}, commonProps, {
          setCurrentFlowAndEntity: setCurrentFlowAndEntity
        }));
        break;
      default:
        console.error('Unrecognized pinned content type ' + content.type);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      className: _style["default"].pinnedContentItem
    }, component);
  }

  /*
   * Overview is old JSON structure. Keeping it only for backwards compatibility
   * Pinned Content is new JSON structure
   */
  function renderOverview() {
    if (!currentModule.overview && currentModule.pinnedContent.length <= 0) {
      return null;
    }
    var overview = /*#__PURE__*/_react["default"].createElement("div", null);
    if (currentModule.overview) {
      overview = /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h5", null, currentModule.overviewTitle || translate[language].overview), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].overviewContent
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: currentModule.overview
      })));
    }
    var pinned = /*#__PURE__*/_react["default"].createElement("div", null);
    if (currentModule.pinnedContent.length) {
      pinned = currentModule.pinnedContent.map(renderPinnedContent);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames7["default"])(_defineProperty(_defineProperty({}, _style["default"].overview, true), _style["default"].lessPadLeft, isOneModule || isMobile))
    }, overview, pinned);
  }
  function getLessonHighlight(lesson) {
    var highlight;
    switch (highlighting) {
      case 'required':
        highlight = lesson.isRequired && /*#__PURE__*/_react["default"].createElement("span", {
          style: {
            color: getHighlightColor()
          },
          className: _style["default"].highlightIcon
        }, /*#__PURE__*/_react["default"].createElement(_circle2["default"], null), "\xA0\xA0");
        break;
      case 'optional':
        highlight = !lesson.isRequired && /*#__PURE__*/_react["default"].createElement("span", {
          style: {
            color: getHighlightColor()
          },
          className: _style["default"].highlightIcon
        }, /*#__PURE__*/_react["default"].createElement(_circle["default"], null), "\xA0\xA0");
        break;
      default:
      // leave undefined
    }
    return highlight;
  }
  function renderLessonArea() {
    var isNextModuleButtonsVisible = false;
    var previousModuleLink = /*#__PURE__*/_react["default"].createElement("span", null);
    if (isMobile && Number.isInteger(currentModuleIndex) && currentModuleIndex >= 1) {
      var prevModule = modules[currentModuleIndex - 1];
      if (prevModule.isAllowed && !prevModule.isEmpty && prevModule.lessons.length > 0) {
        var _prevModule$title;
        isNextModuleButtonsVisible = true;
        previousModuleLink = /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-xs btn-link text-right",
          type: "button",
          onClick: prevModule.setActive
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].arrow
        }, /*#__PURE__*/_react["default"].createElement(_arrowLeft2["default"], {
          spaceRight: true
        })), /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].label
        }, getModuleLabel('previousModule'), ": "), /*#__PURE__*/_react["default"].createElement("span", null, prevModule.title ? (0, _striptags["default"])(((_prevModule$title = prevModule.title) === null || _prevModule$title === void 0 ? void 0 : _prevModule$title.content) || prevModule.title).replace(/&nbsp;/g, ' ').replace(/\*/g, '') : getModuleHeaderText(prevModule))));
      }
    }
    var nextModuleLink = /*#__PURE__*/_react["default"].createElement("span", null);
    if (isMobile && Number.isInteger(currentModuleIndex) && currentModuleIndex >= 0 && currentModuleIndex + 1 < modules.length) {
      var nextModule = modules[currentModuleIndex + 1];
      if (nextModule.isAllowed && !nextModule.isEmpty && nextModule.lessons.length > 0) {
        var _nextModule$title;
        isNextModuleButtonsVisible = true;
        nextModuleLink = /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-xs btn-link text-left",
          type: "button",
          onClick: nextModule.setActive
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].label
        }, getModuleLabel('nextModule'), ": "), /*#__PURE__*/_react["default"].createElement("span", null, nextModule.title ? (0, _striptags["default"])(((_nextModule$title = nextModule.title) === null || _nextModule$title === void 0 ? void 0 : _nextModule$title.content) || nextModule.title).replace(/&nbsp;/g, ' ').replace(/\*/g, '') : getModuleHeaderText(nextModule)), /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].arrow
        }, /*#__PURE__*/_react["default"].createElement(_arrowRight2["default"], {
          spaceLeft: true
        }))));
      }
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames7["default"])(_defineProperty(_defineProperty(_defineProperty({}, _style["default"].lessonWrapper, true), _style["default"].lessMarginLeft, isOneModule || isMobile), _style["default"].noMarginTop, isHideHeader && !('overview' in currentModule)))
    }, renderOverview(), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].lessonArea
    }, currentModule.lessons.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement(_LessonCard["default"], {
        baseColor: baseColor,
        buttonColors: buttonColors,
        getLessonHighlight: getLessonHighlight,
        getLessonLabel: getLessonLabel,
        key: index,
        item: item,
        language: language,
        lessonNum: index,
        lessons: currentModule.lessons,
        progressBubbleColors: progressBubbleColors,
        renderPinnedContent: renderPinnedContent,
        showLastVisited: showLastVisited,
        showLessonNum: showLessonNum,
        showProgressBubbleNum: showProgressBubbleNum
      });
    }), isNextModuleButtonsVisible && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].nextModuleButtons
    }, previousModuleLink, nextModuleLink)));
  }
  return /*#__PURE__*/_react["default"].createElement(NestedContextProvider, {
    context: _cccisdLaravelFlow.ForcedPlayerSettingsContext,
    value: _objectSpread({}, forceAspectRatio ? {
      showStickyBottomBar: false,
      adjustedPlayerWrapperStyle: {
        maxWidth: 'none',
        minHeight: 'none'
      }
    } : {})
  }, /*#__PURE__*/_react["default"].createElement(NestedContextProvider, {
    context: _cccisdLaravelFlow.DefaultPlayerSettingsContext,
    value: {
      background: 'solidColor',
      backgroundColor: '#fff',
      height: isMobile ? '' : '600px' // no min-height for phones, likely to have sticky-nav
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
    loading: isLoading,
    removeChildren: !isNetworkError
  }, renderPlayerView(), renderModuleView())));
};
var _default = exports["default"] = WithModulesMediator;